import { Label } from "@/components/ui/baseUi/label"
import { cn } from "@/modules/lib/utils"
import { Text } from "@/components/ui/baseUi/text"

export type InputContainerProps = {
  children?: React.ReactNode
  description?: string
  label?: string
  isRequiredInput?: boolean
  name?: string
  error?: React.JSX.Element
  className?: string
  labelClassName?: string
} & React.ComponentProps<"div">

/**
 * InputContainer component is a wrapper for form elements with additional features such as labels, error messages, and required indicators.
 */
export function InputContainer({
  children,
  description,
  label,
  name,
  isRequiredInput = false,
  error,
  className,
  labelClassName,
  ...props
}: InputContainerProps) {
  return (
    <div className={cn("flex w-full flex-col gap-1", className)} {...props}>
      {label && (
        <Label htmlFor={name} className={cn(labelClassName)} fontStyle="LM">
          {label.toUpperCase()}
          {isRequiredInput && (
            <Text fontStyle="LM" className="text-red-500">
              {" "}
              *
            </Text>
          )}
        </Label>
      )}
      {description && (
        <Text fontStyle="BS" className="text-textDefault-body">
          {description}
        </Text>
      )}
      {children}
      {error}
    </div>
  )
}
